// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fc064d {
  line-height: 1.2307692308;
  font-size: 0.8125rem;
  text-decoration: underline;
  font-family: "HM Sans Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 400;
  text-transform: none;
  color: var(--base-primary-interactive);
}
.fc064d:hover {
  color: var(--base-primary-interactive-hover);
}
.fc064d:active {
  color: var(--base-primary-interactive-active);
}
.fc064d:focus {
  color: var(--base-primary-interactive);
}
.fc064d:visited {
  color: var(--base-primary-interactive-visited);
}
.ef7263 {
  line-height: 1.45;
  font-size: 0.688rem;
  text-decoration: underline;
  font-family: "HM Sans Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 400;
  text-transform: none;
}
.dd3d91 {
  line-height: 1.2307692308;
  font-size: 0.8125rem;
  text-decoration: underline;
  font-family: "HM Sans Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 400;
  text-transform: none;
}
.f3e1f9 {
  line-height: 1.25;
  font-size: 1rem;
  text-decoration: underline;
  font-family: "HM Sans Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 400;
  text-transform: none;
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/Typography/links/InlineLink/InlineLink.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;EAC1B,wIAAwI;EACxI,gBAAgB;EAChB,oBAAoB;EACpB,sCAAsC;AACxC;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,wIAAwI;EACxI,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;EAC1B,wIAAwI;EACxI,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,wIAAwI;EACxI,gBAAgB;EAChB,oBAAoB;AACtB","sourcesContent":[".fc064d {\n  line-height: 1.2307692308;\n  font-size: 0.8125rem;\n  text-decoration: underline;\n  font-family: \"HM Sans Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 400;\n  text-transform: none;\n  color: var(--base-primary-interactive);\n}\n.fc064d:hover {\n  color: var(--base-primary-interactive-hover);\n}\n.fc064d:active {\n  color: var(--base-primary-interactive-active);\n}\n.fc064d:focus {\n  color: var(--base-primary-interactive);\n}\n.fc064d:visited {\n  color: var(--base-primary-interactive-visited);\n}\n.ef7263 {\n  line-height: 1.45;\n  font-size: 0.688rem;\n  text-decoration: underline;\n  font-family: \"HM Sans Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 400;\n  text-transform: none;\n}\n.dd3d91 {\n  line-height: 1.2307692308;\n  font-size: 0.8125rem;\n  text-decoration: underline;\n  font-family: \"HM Sans Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 400;\n  text-transform: none;\n}\n.f3e1f9 {\n  line-height: 1.25;\n  font-size: 1rem;\n  text-decoration: underline;\n  font-family: \"HM Sans Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 400;\n  text-transform: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
